/* eslint-disable prettier/prettier */
import React from "react";
import moment from "moment";

import { useDashboard } from "../../DashboardPage/useDashboard";
import DiamondCardModal from "../../DashboardPage/DiamondCardModal";
import DiamondMapper from "./DiamondProvider/DiamondMapper";
import DiamondModalMapper from "./DiamondProvider/DiamondModalMapper";

import styles from "./DiamondCardModalWrapper.module.css";

const DiamondCardModalWrapper = ({
  user,
  onSwapCompleted,
  onUpdateCompleted,
  onClose,
  activeTab,
}) => {
  const { swapIBOPost, userEditPut } = useDashboard(null, true, true);

  const mapToUpdate = (user) => {
    const profilePicture = user.picture;
    const profilePictureB =
      user.iboB && user.iboB.photoUrl ? user.iboB.photoUrl : null;

    return {
      userId: user.userId,
      iboNumber: user.iboNum,
      accessLevel: user.accessLevel,
      profile: {
        spouse: user.spouse,
        birthday: user.birthdate,
        anniversary: user.anniversary,
        ...(user.isPhotoChanged && {
          photoUrl: {
            name: "New Profile Picture",
            data: profilePicture,
            mimetype: profilePicture.substring(
              "data:".length,
              profilePicture.indexOf(";base64")
            ),
          },
        }),
      },
      profileB: {
        ...user.iboB,
        ...(user.isPhotoBChanged && {
          photoUrl: profilePictureB
            ? {
                name: "New Profile Picture",
                data: profilePictureB,
                mimetype:
                  profilePictureB &&
                  profilePictureB.length > 0 &&
                  profilePictureB.substring(
                    "data:".length,
                    profilePictureB.indexOf(";base64")
                  ),
              }
            : null,
        }),
      },
      businessInfo: {
        uplineDiamond: user.uplineDiamond,
        yearVotingMemberQualified: user.yearVotingMemberQualified,
        qualifyingRequirementsByYear: [
          {
            year: user.yearQualifyingRequirements,
          },
        ],
      },
      gracePeriod: {
        isGracePeriod: user.gracePeriod,
        startedOn: user.gracePeriodStarted,
      },
      eventInfo: {
        hasFamilyReunion: user.familyReunion,
        firstFamilyReunion: user.firstFamilyReunion,
        attendanceAtLastFamilyReunion: user.familyReunionAttendance,
      },
    };
  };

  const mutateSwapIbo = async (user) => {
    onClose();

    await swapIBOPost.mutateAsync(user.userId);

    onSwapCompleted && onSwapCompleted();
  };

  const mutateUpdateUser = async (user) => {
    const updateUser = mapToUpdate(user);

    await userEditPut.mutate(updateUser);

    onUpdateCompleted && onUpdateCompleted();
  };

  const _user = DiamondModalMapper(DiamondMapper(user));

  return (
    _user !== null && (
      <div className={styles.diamondCardModal}>
        <DiamondCardModal
          isOpen={true}
          diamondInfo={_user}
          onSwap={(user) => mutateSwapIbo(user)}
          onSave={(user) => mutateUpdateUser(user)}
          onClose={onClose}
          activeTab={activeTab}
        />
      </div>
    )
  );
};

export default DiamondCardModalWrapper;
